export default {
  exchangeEmails: [],
  exchangeEmail: undefined,
};
